import React from "react";
import styles from "../document/document.module.css";
import backgroundImage from "./../../assets/16.09.2022-2-1-2.jpg";

export const Moswservice = () => {
  const documentList = [
    {
      name: "რემედიაციის პროგრამა",
      filename: "remediacia.pdf",
    },
    {
      name: "მოსწავლის, პერსონალის, მშობლის/კანონიერი წარმომადგენლის უფლებების დაცვის პოლიტიკა",
      filename: "uflebispolitika.pdf",
    },
    {
      name: "უსაფრთხოებისა და საზოგადოებრივი წესრიგის დაცვის წესი და პირობები",
      filename:
        "usafrtxoebis_da_sazogadoebrivi_westigis_dacvis_wesi_da_pirobebi.pdf",
    },
    {
      name: "ბავშვის მიმართ განხორციელებული ძალადობასთან დაკავშირებული შიდა ინსტრუქციების დამტკიცებისა და უფლებამოსილების პირის განსაზღვრის შესახებ",
      filename: "dzaladoba.pdf",
    },
    {
      name: "განცხადებისა და საჩივრის განხილვის წესი",
      filename: "sachivari.pdf",
    },
  ];

  const backgroundStyle = {
    backgroundImage: `url(${backgroundImage})`,
    backgroundSize: "cover",
    height: "100vh",
  };

  return (
    <div style={backgroundStyle}>
      <div className={styles.documentsPage}>
        <header className={styles.header}>
          <h1>მოსწავლეთა მხარდაჭერის სერვისები</h1>
        </header>
        <div className={styles.documentsContainer}>
          {documentList.map((doc, index) => (
            <a
              key={index}
              className={styles.documentBox}
              target="_blank"
              rel="noreferrer noopener"
              href={`https://batumi-gimnazia.edu.ge/documents/${doc.filename}`}
            >
              {doc.name}
            </a>
          ))}
        </div>
      </div>
    </div>
  );
};
